var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { User } from './User';
import { Entity } from './Entity';
import { enumerable } from '../util/enumerable';
export class Role extends Entity {
    constructor() {
        super(...arguments);
        /**
         * A set of users which have this role
         */
        this.users = null;
        /**
         * The name of the role
         */
        this.name = null;
    }
    /**
     * Test if the given user has this role
     * @param user The user to check
     * @return <code>true</code> if the given user has this role,
     * otherwise <code>false</code>
     */
    hasUser(user) {
        return !!this.users && this.users.has(user);
    }
    /**
     * Add the given user to this role
     * @param user The user to add
     */
    addUser(user) {
        if (user instanceof User) {
            if (!this.users) {
                this.users = new Set();
            }
            this.users.add(user);
        }
        else {
            throw new Error('Only user instances can be added to a role.');
        }
    }
    /**
     * Remove the given user from this role
     * @param user The user to remove
     */
    removeUser(user) {
        if (user instanceof User) {
            if (this.users) {
                this.users.delete(user);
            }
        }
        else {
            throw new Error('Only user instances can be removed from a role.');
        }
    }
}
__decorate([
    enumerable(false)
], Role.prototype, "hasUser", null);
__decorate([
    enumerable(false)
], Role.prototype, "addUser", null);
__decorate([
    enumerable(false)
], Role.prototype, "removeUser", null);
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiUm9sZS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIlJvbGUudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7O0FBQ0EsT0FBTyxFQUFFLElBQUksRUFBRSxNQUFNLFFBQVEsQ0FBQztBQUM5QixPQUFPLEVBQUUsTUFBTSxFQUFFLE1BQU0sVUFBVSxDQUFDO0FBQ2xDLE9BQU8sRUFBRSxVQUFVLEVBQUUsTUFBTSxvQkFBb0IsQ0FBQztBQUVoRCxNQUFNLE9BQU8sSUFBSyxTQUFRLE1BQU07SUFBaEM7O1FBQ0U7O1dBRUc7UUFDSSxVQUFLLEdBQTJCLElBQUksQ0FBQztRQUU1Qzs7V0FFRztRQUNJLFNBQUksR0FBa0IsSUFBSSxDQUFDO0lBNENwQyxDQUFDO0lBMUNDOzs7OztPQUtHO0lBRUgsT0FBTyxDQUFDLElBQWdCO1FBQ3RCLE9BQU8sQ0FBQyxDQUFDLElBQUksQ0FBQyxLQUFLLElBQUksSUFBSSxDQUFDLEtBQUssQ0FBQyxHQUFHLENBQUMsSUFBSSxDQUFDLENBQUM7SUFDOUMsQ0FBQztJQUVEOzs7T0FHRztJQUVILE9BQU8sQ0FBQyxJQUFnQjtRQUN0QixJQUFJLElBQUksWUFBWSxJQUFJLEVBQUU7WUFDeEIsSUFBSSxDQUFDLElBQUksQ0FBQyxLQUFLLEVBQUU7Z0JBQ2YsSUFBSSxDQUFDLEtBQUssR0FBRyxJQUFJLEdBQUcsRUFBRSxDQUFDO2FBQ3hCO1lBRUQsSUFBSSxDQUFDLEtBQUssQ0FBQyxHQUFHLENBQUMsSUFBSSxDQUFDLENBQUM7U0FDdEI7YUFBTTtZQUNMLE1BQU0sSUFBSSxLQUFLLENBQUMsNkNBQTZDLENBQUMsQ0FBQztTQUNoRTtJQUNILENBQUM7SUFFRDs7O09BR0c7SUFFSCxVQUFVLENBQUMsSUFBZ0I7UUFDekIsSUFBSSxJQUFJLFlBQVksSUFBSSxFQUFFO1lBQ3hCLElBQUksSUFBSSxDQUFDLEtBQUssRUFBRTtnQkFDZCxJQUFJLENBQUMsS0FBSyxDQUFDLE1BQU0sQ0FBQyxJQUFJLENBQUMsQ0FBQzthQUN6QjtTQUNGO2FBQU07WUFDTCxNQUFNLElBQUksS0FBSyxDQUFDLGlEQUFpRCxDQUFDLENBQUM7U0FDcEU7SUFDSCxDQUFDO0NBQ0Y7QUFuQ0M7SUFEQyxVQUFVLENBQUMsS0FBSyxDQUFDO21DQUdqQjtBQU9EO0lBREMsVUFBVSxDQUFDLEtBQUssQ0FBQzttQ0FXakI7QUFPRDtJQURDLFVBQVUsQ0FBQyxLQUFLLENBQUM7c0NBU2pCIn0=